import {pallet} from './pallet';

export const themeVariants: {[key: string]: any} = {
  default: {
    pallet: pallet,
  },
};

export const theme = themeVariants.default;
